import gql from "graphql-tag";

const getCountries = (schema) => gql`
  query getCountries {
    pdt_country {
      description
      code
      isd
      display_order
    }
  }
`;

export default getCountries;
